import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { insertNewLine } from '@/utils';
import Placeholder from '@/components/Placeholder';
import { TABLET_L } from '@/constants';
import Image from '../../../components/ContentfulImage';
import Slider from '../../../components/Slider/Slider';
import Markdown from '../../../components/Markdown';
import Video from '../../../components/BrightcoveVideo';

import {
  Wrapper,
  Title,
  TitleBottomWrapper,
  TitleBottom,
  SectionTitle,
  SectionTitleWrapper,
  MarkdownStyle,
  ContentsWrapper,
  SliderWrapper,
  ContentWrapper,
  ContentsLeft,
  Description,
  ButtonWrapper,
  Button,
  Section,
} from './Trend.style';

const Trend = ({ index, parentSlug, locale, trend, isLast, title, screenSize, sectionTitle, isTitleBottom }) => (
  <Wrapper
    image={trend.secondaryImage && trend.secondaryImage.file}
    showSecondaryImage={trend.secondaryImage && !isLast}
  >
    <SectionTitleWrapper>
      {!sectionTitle ? <Placeholder w="100%" h="100px" /> : <SectionTitle>{sectionTitle}</SectionTitle>}
    </SectionTitleWrapper>
    {trend.creatorsVideo ? (
      <Section>
        <Video {...trend.creatorsVideo} />
      </Section>
    ) : null}

    <ContentsWrapper direction={screenSize > TABLET_L ? 'row' : 'column'}>
      <ContentsLeft>
        <SliderWrapper>
          {trend.images.length > 1 ? (
            <Slider
              dots
              dotsColor="#333"
              dotsStyle={{ bottom: -35 }}
              keys={trend.images.map(({ title }) => title)}
              options={{
                easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                loop: true,
                perPage: 1,
              }}
            >
              {trend.images.map(image => (
                <Image
                  key={image.assetId}
                  src={image}
                  options={{ w: 'auto', size: [0, 0, 600, 720], aspectRatio: ['unset', 9 / 10], objectFit: 'cover' }}
                />
              ))}
            </Slider>
          ) : (
            <Image
              src={trend.images[0]}
              options={{
                w: '100%',
                objectFit: 'contain',
                objectPosition: 'top',
              }}
            />
          )}
        </SliderWrapper>

        {isTitleBottom && (
          <TitleBottomWrapper>
            {!title ? <Placeholder w="100%" h="100px" /> : <TitleBottom>{title}</TitleBottom>}
          </TitleBottomWrapper>
        )}
      </ContentsLeft>

      <ContentWrapper left={index % 2 !== 0}>
        {!isTitleBottom && (
          <Title>
            {insertNewLine({ key: 'trend', description: title, component: MarkdownStyle }) || (
              <Placeholder w="100%" h="100%" />
            )}
          </Title>
        )}
        <Markdown src={trend.description} Component={Description} />
        {/* リンク遷移させない場合は、ボタン部分をトリツメ */}
        {_.get(trend, 'linkYn') && (
          <React.Fragment>
            {!_.get(trend, 'linkSection.label') &&
            _.get(trend, 'linkSection.inspirationArticle.slug') &&
            !parentSlug &&
            !locale ? (
              <Placeholder w="100%" h="50px" />
            ) : (
              <ButtonWrapper>
                <Link
                  to={`/${locale}/inspiration/${parentSlug}/${trend.linkSection.inspirationArticle.slug}`}
                  href={`/${locale}/inspiration/${parentSlug}/${trend.linkSection.inspirationArticle.slug}`}
                >
                  <Button>{trend.linkSection.label}</Button>
                </Link>
              </ButtonWrapper>
            )}
          </React.Fragment>
        )}
      </ContentWrapper>
    </ContentsWrapper>
  </Wrapper>
);

Trend.defaultProps = {
  screenSize: null,
};

Trend.propTypes = {
  parentSlug: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  trend: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
  isLast: PropTypes.bool.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  Title: PropTypes.string.isRequired,
  isTitleBottom: PropTypes.bool.isRequired,
  // スクリーンサイズ
  screenSize: PropTypes.number,
};

export default Trend;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/Trend/Trend.js